import apiClient from './client';

export const bitrixAPI = {
  /**
   * Получить статус подключения к Bitrix24
   */
  getStatus: async () => {
    const response = await apiClient.get('/bitrix/status');
    return response.data;
  },

  /**
   * Получить конфигурацию Bitrix (только Admin)
   */
  getConfig: async () => {
    const response = await apiClient.get('/bitrix/config');
    return response.data;
  },

  /**
   * Запустить полную синхронизацию (только Admin)
   */
  runFullSync: async () => {
    const response = await apiClient.post('/bitrix/sync/full');
    return response.data;
  },

  /**
   * Запустить инкрементальную синхронизацию (только Admin)
   */
  runIncrementalSync: async () => {
    const response = await apiClient.post('/bitrix/sync/incremental');
    return response.data;
  },

  /**
   * Синхронизировать одну задачу (только Admin)
   * @param {string} taskId - ID задачи в Bitrix
   */
  syncTask: async (taskId) => {
    const response = await apiClient.post(`/bitrix/sync/task/${taskId}`);
    return response.data;
  },

  /**
   * Получить статистику синхронизации
   */
  getStats: async () => {
    const response = await apiClient.get('/bitrix/stats');
    return response.data;
  },

  /**
   * Search users in Bitrix24 + local employees by name or ID
   * @param {string} query - search query (name or Bitrix user ID)
   */
  searchUsers: async (query) => {
    const response = await apiClient.get('/bitrix/users/search', { params: { q: query } });
    return response.data;
  },

  /**
   * Search workgroups in Bitrix24 + local client names
   * @param {string} query - search query (group name)
   */
  searchGroups: async (query) => {
    const response = await apiClient.get('/bitrix/groups/search', { params: { q: query } });
    return response.data;
  },

  /**
   * Create a new workgroup (project) in Bitrix24
   * @param {string} name - workgroup name
   */
  createGroup: async (name) => {
    const response = await apiClient.post('/bitrix/groups/create', { name });
    return response.data;
  },

  /**
   * Получить комментарии к задаче Bitrix24
   * @param {string} taskId - ID задачи в Bitrix
   */
  getTaskComments: async (taskId) => {
    const response = await apiClient.get(`/bitrix/tasks/${taskId}/comments`);
    return response.data;
  },

  /**
   * Синхронизировать статусы подзадач Bitrix → этапы PCC
   * @param {string} taskId - ID мастер-задачи в Bitrix
   * @param {string} projectId - ID проекта в PCC
   */
  syncStages: async (taskId, projectId) => {
    const response = await apiClient.post(`/bitrix/tasks/${taskId}/sync-stages`, {
      project_id: projectId,
    });
    return response.data;
  },

  /**
   * Ensure a Bitrix user exists as a local employee
   * @param {string} name - full name
   * @param {string|null} bitrixId - Bitrix user ID (optional)
   */
  ensureEmployee: async (name, bitrixId) => {
    const response = await apiClient.post('/bitrix/users/ensure-employee', {
      name,
      bitrix_id: bitrixId,
    });
    return response.data;
  },
};
